var _ellipse, _g, _ellipse2, _path, _path2, _ellipse3, _path3, _path4, _ellipse4, _path5, _path6, _path7, _path8, _circle, _circle2, _path9, _path10, _circle3, _circle4, _path11, _path12, _polygon, _path13, _path14, _path15, _rect, _polygon2, _rect2, _rect3, _rect4, _rect5, _path16, _path17, _path18, _circle5, _circle6, _path19, _path20, _path21, _path22, _rect6, _path23, _path24, _path25, _path26, _circle7, _circle8, _circle9, _path27, _path28, _path29, _path30, _ellipse5, _ellipse6, _path31, _path32, _path33, _path34, _path35, _path36, _ellipse7, _polyline, _rect7, _path37, _rect8, _path38;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgVehicleSale(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Layer 1",
    width: 1114,
    height: 593.54145,
    viewBox: "0 0 1114 593.54145",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Vehicle sale") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 557,
    cy: 419.76597,
    rx: 557,
    ry: 173.77547,
    fill: "#a0182f",
    opacity: 0.1
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("path", {
    d: "M447.792,188.61069c9.4427,13.24168,16.687,51.80564,18.70621,63.42625l16.87916-.34435c-.87347-9.98352-20.50928-50.59144-25.96792-61.73352C454.372,189.48286,451.12986,189.01776,447.792,188.61069Z",
    transform: "translate(-43 -153.22928)",
    fill: "#65617d"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 235.50336,
    y: 181.59265,
    width: 10.53355,
    height: 7.47767,
    transform: "translate(7.92518 269.32977) rotate(-88.91801)",
    fill: "#dce0ed"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.13142,179.99505l-.06476,3.42915a5.71053,5.71053,0,0,0,1.62072.25l5.85242.06065.068-3.5986Z",
    transform: "translate(-43 -153.22928)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.2712,153.36412l-7.059-.13332a8.47282,8.47282,0,0,0-7.9484,5.13905c-2.16363,5.0498-4.06611,13.10879.38065,21.26595a5.83528,5.83528,0,0,0,5.06083,3.04224l9.01053.093Z",
    transform: "translate(-43 -153.22928)",
    fill: "#dce0ed"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 247.9935,
    cy: 168.06759,
    rx: 14.70609,
    ry: 7.56076,
    transform: "translate(32.27297 259.61394) rotate(-88.91801)",
    fill: "#f0f0f4"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 302.58376,
    y: 182.31618,
    width: 9.22246,
    height: 7.47767,
    transform: "translate(72.37232 336.45264) rotate(-88.91801)",
    fill: "#dce0ed"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M303.5439,181.374l-.05536,2.93072a5.71024,5.71024,0,0,0,1.62072.25l5.85242.06065.05856-3.10017Z",
    transform: "translate(-43 -153.22928)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M314.68367,154.74307l-7.059-.13332a8.47283,8.47283,0,0,0-7.9484,5.13906c-2.16363,5.04979-4.06611,13.10879.38065,21.26594a5.83528,5.83528,0,0,0,5.06083,3.04224l9.01053.093Z",
    transform: "translate(-43 -153.22928)",
    fill: "#dce0ed"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 314.40597,
    cy: 169.44654,
    rx: 14.70609,
    ry: 7.56076,
    transform: "matrix(0.01888, -0.99982, 0.99982, 0.01888, 96.05265, 327.36749)",
    fill: "#f0f0f4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M312.69581,160.082s2.78.49882,1.26052,4.15221a25.43232,25.43232,0,0,0-1.77841,5.54533s-2.81585,1.39734-2.61373-3.39672S312.69581,160.082,312.69581,160.082Z",
    transform: "translate(-43 -153.22928)",
    fill: "#dce0ed"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 592.05659,
    cy: 375.54331,
    rx: 48.35562,
    ry: 44.11827,
    transform: "translate(162.40031 807.17359) rotate(-88.91801)",
    fill: "#636780"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M576.38435,329.9c23.05422,1.98855,40.9417,23.34113,40.45648,49.03256-.39112,20.70876-12.60527,38.14911-29.43239,44.721C564.3542,421.665,546.46678,400.31241,546.952,374.621,547.34312,353.91225,559.55724,336.47189,576.38435,329.9Z",
    transform: "translate(-43 -153.22928)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 248.81146,
    cy: 263.35728,
    rx: 46.69392,
    ry: 35.80975,
    transform: "translate(-62.19722 353.92207) rotate(-88.91801)",
    fill: "#636780"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M259.66308,218.81621c14.74153,5.97106,25.24563,24.07518,24.84516,45.27929-.428,22.65958-13.1659,41.31223-29.668,45.24689-14.74153-5.97106-25.24563-24.07515-24.84516-45.27926C230.42308,241.40352,243.161,222.75087,259.66308,218.81621Z",
    transform: "translate(-43 -153.22928)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M383.49079,255.9289,383.14628,238.97s3.46089-7.24745,6.79625-7.84925,10.9857-.87282,10.9857-.87282,5.52138,24.4526,1.39593,31.68749S383.49079,255.9289,383.49079,255.9289Z",
    transform: "translate(-43 -153.22928)",
    fill: "#65617d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M383.49079,255.9289,383.14628,238.97s3.46089-7.24745,6.79625-7.84925,10.9857-.87282,10.9857-.87282,5.52138,24.4526,1.39593,31.68749S383.49079,255.9289,383.49079,255.9289Z",
    transform: "translate(-43 -153.22928)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M444.8313,255.25921s2.50368-23.45907-10.404-24.12579c-1.66083-.08579-3.32174-.15712-4.97373-.34862-8.93451-1.0357-33.30816-3.38007-30.48934,2.25142,0,0,5.429,20.54515,1.34432,25.62021Z",
    transform: "translate(-43 -153.22928)",
    fill: "#65617d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M261.0042,295.37334l-17.3296.1713s-2.38808-31.95553-3.33785-34.46647-1.22228-14.4825,2.05041-16.16579,14.1534-3.59685,14.1534-3.59685l7.63117,18.343.31238,16.45971Z",
    transform: "translate(-43 -153.22928)",
    fill: "#65617d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M261.0042,295.37334l-17.3296.1713s-2.38808-31.95553-3.33785-34.46647-1.22228-14.4825,2.05041-16.16579,14.1534-3.59685,14.1534-3.59685l7.63117,18.343.31238,16.45971Z",
    transform: "translate(-43 -153.22928)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M303.87189,243.20666l.14432-3.551a2.04961,2.04961,0,0,0-2.096-2.13228c-8.59156.20016-39.85607,1.1064-45.3796,3.79213,0,0,5.14092,44.59719-1.66322,55.06394l1.56984,35.67959,76.61614-4.28689Z",
    transform: "translate(-43 -153.22928)",
    fill: "#65617d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M310.914,187.14239c-2.11933-.24943-4.642-.52644-7.46392-.79912l-.08029,4.25156,7.47634.1412Z",
    transform: "translate(-43 -153.22928)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M236.94268,189.98842l-.01016.53831,7.47634.1412.06109-3.23476A31.93775,31.93775,0,0,0,236.94268,189.98842Z",
    transform: "translate(-43 -153.22928)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "154.434 142.065 165.73 142.443 189.878 100.458 193.909 93.449 191.257 75.45 188.878 79.753 154.434 142.065",
    fill: "#dce0ed"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "257.596 91.825 262.115 98.891 276.376 80.353 282.903 71.86 279.178 66.64 276.185 70.133 257.596 91.825",
    fill: "#dce0ed"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M319.18476,223.36238c-.02673.35847-.05362.72692-.0856,1.10027l.27648,9.11965,6.52754-8.49255-3.72566-5.22088Z",
    transform: "translate(-43 -153.22928)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "188.878 79.753 189.878 100.458 193.909 93.449 191.257 75.45 188.878 79.753",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M332.163,236.84368s6.36492-41.5649-13.82513-48.17882a4.59123,4.59123,0,0,0-.79492-.17933c-4.66286-.65248-48.13714-6.49859-70.87266-.956,0,0-15.495,2.03415-15.48578,10.34433l4.89456,101.64074,11.13144.21024-2.38742-67.19s-4.76425-29.34121,4.07888-31.16859,48.94583-4.394,62.9925-.13989c0,0,10.34466-2.13143,8.20317,23.25675l.40726,13.63611Z",
    transform: "translate(-43 -153.22928)",
    fill: "#dce0ed"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M298.03648,248.58106a6.42651,6.42651,0,0,1,2.725-5.68244c3.15986-2.30868,12.851-7.2363,12.851-7.2363l3.11043.30805,8.9077,23.35315L324.078,308.531l-17.21478,20.49144Z",
    transform: "translate(-43 -153.22928)",
    fill: "#65617d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M298.03648,248.58106a6.42651,6.42651,0,0,1,2.725-5.68244c3.15986-2.30868,12.851-7.2363,12.851-7.2363l3.11043.30805,8.9077,23.35315L324.078,308.531l-17.21478,20.49144Z",
    transform: "translate(-43 -153.22928)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M364.18311,301.43549l.62162-50.51311s1.86553-19.57639-9.84113-20.12988c0,0-27.62919-.3206-39.70039,3.34911a2.6812,2.6812,0,0,0-1.58495,3.84343c2.31084,4.20466,6.13231,15.28988,7.54367,43.56759l-.57187,30.27918Z",
    transform: "translate(-43 -153.22928)",
    fill: "#65617d"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "262.3 179.378 312.583 179.156 312.633 179.157 337.345 179.051 335.103 145.976 321.387 146.216 277.591 155.111 263.863 175.793 262.3 179.378",
    fill: "#65617d"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "262.3 179.378 312.583 179.156 312.633 179.157 337.345 179.051 335.103 145.976 321.387 146.216 277.591 155.111 263.863 175.793 262.3 179.378",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "262.3 179.378 312.583 179.156 313.828 157.042 277.591 155.111 263.863 175.793 262.3 179.378",
    fill: "#65617d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M355.63257,332.38665l24.71265-.10663-2.24228-33.07464s-7.95854,12.19006-21.27487,11.066Z",
    transform: "translate(-43 -153.22928)",
    fill: "#fff",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.844,355.75384c.818,9.48886,7.57493,8.12067,7.57493,8.12067l1.2582-.09093,12.472-.89625-.22072-14.71289a54.10713,54.10713,0,0,0-12.64439.519C181.59561,349.57222,177.47989,351.53877,177.844,355.75384Z",
    transform: "translate(-43 -153.22928)",
    fill: "#dce0ed"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.844,355.75384c.818,9.48886,7.57493,8.12067,7.57493,8.12067l1.2582-.09093a12.72462,12.72462,0,0,0,2.11805-7.075,11.96694,11.96694,0,0,0-2.5112-8.01508C181.59561,349.57222,177.47989,351.53877,177.844,355.75384Z",
    transform: "translate(-43 -153.22928)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M351.61824,262.72283c-.29027,15.3693,8.698,28.0028,20.07588,28.21769s20.8368-12.0702,21.12708-27.4395-8.698-28.0028-20.07591-28.21769S351.90852,247.35353,351.61824,262.72283Zm7.77412,1.975c.21056-11.14849,7.41051-20.05336,16.08156-19.88959s15.52963,9.33415,15.31907,20.48264-7.41052,20.05336-16.08156,19.8896S359.1818,275.84634,359.39236,264.69787Z",
    transform: "translate(-43 -153.22928)",
    fill: "#636780"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "328.061 118.42 318.246 127.708 314.917 119.169 329.027 111.292 328.061 118.42",
    fill: "#636780"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "315.626 24.424 307.217 25.287 304.035 28.926 308.353 50.248 317.733 84.646 323.868 108.256 328.227 122.605 330.819 141.535 333.523 154.566 342.203 163.58 360.593 142.687 363.676 135.665 371.027 121.349 352.904 112.451 332.884 110.303 323.904 85.943 316.766 57.782 315.626 24.424",
    fill: "#a0182f"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "483.428 128.833 492.655 221.083 354.702 212.66 371.505 167.771 398.414 150.994 337.587 150.843 337.732 125.583 362.421 120.731 412.006 117.679 449.253 116.72 484.588 129.022",
    fill: "#65617d"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "483.428 128.833 492.655 221.083 354.702 212.66 371.505 167.771 398.414 150.994 337.587 150.843 337.732 125.583 362.421 120.731 412.006 117.679 449.253 116.72 484.588 129.022",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M336.07335,370.2302c-.432,22.87216,6.77363,43.83688,27.90348,41.95549,26.60673-.06761,29.03584-17.99978,29.46781-40.872s-12.08954-40.1365-27.93218-40.43572S336.50533,347.358,336.07335,370.2302Z",
    transform: "translate(-43 -153.22928)",
    fill: "#636780"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M335.90667,370.26591c.33444-17.70793,8.30172-31.76108,19.23415-37.06671,13.85524,2.90687,24.24395,19.10356,23.84984,39.97084-.354,18.74393-2.053,34.16736-17.29707,39.16256C342.19821,412.66494,335.48946,392.35629,335.90667,370.26591Z",
    transform: "translate(-43 -153.22928)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "266.655 180.592 274.589 190.034 260.039 187.252 249.317 177.019 239.953 157.372 226.398 148.708 192.693 152.644 161.558 153.236 150.265 142.818 163.111 141.317 176.092 141.268 208.693 141.146 247.492 140.846 255.054 162.23 260.824 176.941 266.655 180.592",
    fill: "#a0182f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.36226,369.58468c.64412,1.00937,22.34744,4.74493,22.34744,4.74493l59.9326,12.10113L382.957,389.8778l12.32121-10.07336,6.34849,1.25171.25831.04976L486.68045,397.82l1.3894-.17321,23.254-2.86651,121.45278-14.9777-1.02362-17.61-.60646-10.39232-1.25281-21.57815-1.05955-5.67416L618.067,323.3574l-5.03029-.5587-78.48-8.697L524.297,312.96561l-5.75179-.63714-56.013-8.70145-81.94346.44677.143-25.26138L350.217,178.516c-7.16434,1.02641-7.09088,5.84928-7.09088,5.84928L368.931,278.75406l-.75492,57.65888c-57.46788,4.70836-59.081-7.822-68.23685-3.78177L289.636,297.37l-96.36952-1.32149C189.35581,300.6266,197.36226,369.58468,197.36226,369.58468Z",
    transform: "translate(-43 -153.22928)",
    fill: "#65617d"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "394.426 168.536 362.616 233.585 352.251 236.711 349.962 226.033 362.113 189.864 374.307 168.987 394.426 168.536",
    fill: "#65617d"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "394.426 168.536 362.616 233.585 352.251 236.711 349.962 226.033 362.113 189.864 374.307 168.987 394.426 168.536",
    opacity: 0.15
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 455.95795,
    cy: 394.41269,
    rx: 62.81246,
    ry: 55.37461,
    transform: "matrix(0.01888, -0.99982, 0.99982, 0.01888, 10.00564, 689.61229)",
    fill: "#636780"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M437.32147,335.156c28.935,2.56395,51.36889,30.28516,50.7386,63.65753-.508,26.9-15.85314,49.56436-36.97923,58.11485-28.935-2.564-51.36884-30.2852-50.73855-63.65754C400.85034,366.37078,416.19539,343.70646,437.32147,335.156Z",
    transform: "translate(-43 -153.22928)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M606.43566,287.39805l2.49733,12.97088,7.64093,39.73819,36.12178-2.808s2.28366-6.60322-3.31641-9.202c0,0-1.42929-22.52883-7.95943-29.73729a6.78036,6.78036,0,0,0-2.58227-1.87364Z",
    transform: "translate(-43 -153.22928)",
    fill: "#65617d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M608.933,300.36893l7.64093,39.73819,36.12178-2.808s2.28366-6.60322-3.31641-9.202c0,0-1.42929-22.52883-7.95943-29.73729Z",
    transform: "translate(-43 -153.22928)",
    fill: "#fff",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M525.12687,289.3526c-4.79771,7.71746,5.13782,79.87312,5.13782,79.87312l88.83094-12.95124-1.96581-63.02531c-1.6158-11.33381-8.23475-12.78508-8.23475-12.78508-30.938-16.375-102.64809-21.055-102.64809-21.055-65.50493,1.25584-125.51519,19.40335-125.51519,19.40335C455.37777,268.75441,525.12687,289.3526,525.12687,289.3526Z",
    transform: "translate(-43 -153.22928)",
    fill: "#65617d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M530.26469,369.22572l88.83094-12.95124-1.96581-63.02531c-1.6158-11.33381-8.23475-12.78508-8.23475-12.78508s-64.51429-7.3712-83.7682,8.88851C520.32916,297.07006,530.26469,369.22572,530.26469,369.22572Z",
    transform: "translate(-43 -153.22928)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M539.70459,365.24735l74.27861-11.07848L612.35982,300.397c-1.34737-9.66936-6.88121-10.90544-6.88121-10.90544s-53.94013-6.26823-70.04418,7.61058C531.42042,303.68814,539.70459,365.24735,539.70459,365.24735Z",
    transform: "translate(-43 -153.22928)",
    fill: "#65617d"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 546.63059,
    cy: 321.16891,
    rx: 18.44493,
    ry: 10.1364,
    transform: "translate(172.1968 708.40806) rotate(-88.91801)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 546.64,
    cy: 320.67049,
    rx: 18.44493,
    ry: 10.1364,
    transform: "translate(172.70437 707.92846) rotate(-88.91801)",
    fill: "#dce0ed"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M545.56818,307.02183s4.141.743,1.87759,6.18487a37.88258,37.88258,0,0,0-2.649,8.26s-4.19431,2.08138-3.89325-5.05954S545.56818,307.02183,545.56818,307.02183Z",
    transform: "translate(-43 -153.22928)",
    fill: "#f0f0f4"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 601.09673,
    cy: 314.88478,
    rx: 17.23543,
    ry: 9.47172,
    transform: "translate(231.91745 756.69902) rotate(-88.91801)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 601.10614,
    cy: 314.38636,
    rx: 17.23543,
    ry: 9.47172,
    transform: "translate(232.42502 756.21942) rotate(-88.91801)",
    fill: "#dce0ed"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M600.03431,300.73771s4.141.743,1.87759,6.18486a37.88206,37.88206,0,0,0-2.649,8.26s-4.19431,2.08139-3.89325-5.05954S600.03431,300.73771,600.03431,300.73771Z",
    transform: "translate(-43 -153.22928)",
    fill: "#f0f0f4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M558.55709,305.76966c.53423,6.826,2.90483,57.39392,2.90483,57.39392l5.65495-.83553,3.14489-.45916,4.19-.61889.505-.07525,16.50472-2.43058-2.23784-53.63683a6.71636,6.71636,0,0,0-6.66448-6.43315c-.16455.00188-.33412.00364-.50385.01541-1.1383.07823-2.36669.17469-3.64529.29013-.5394.04964-1.08383.09922-1.63838.15853-1.58357.15956-3.21776.35806-4.82269.592-.82006.12414-1.62524.25351-2.42064.39306-1.34584.24384-2.64731.51342-3.84981.82479-.81667.20892-1.59383.43856-2.3066.68937C560.38093,302.65794,558.41588,304.007,558.55709,305.76966Z",
    transform: "translate(-43 -153.22928)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M582.5591,298.67419l2.08258,60.27526,1.83231-.12994-2.06027-59.871A6.74685,6.74685,0,0,0,582.5591,298.67419Z",
    transform: "translate(-43 -153.22928)",
    fill: "#65617d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M576.77158,299.13826l1.86709,60.85953,2.82605.05337L578.41,298.97973C577.87056,299.02937,577.32613,299.079,576.77158,299.13826Z",
    transform: "translate(-43 -153.22928)",
    fill: "#65617d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M569.52825,300.12331l3.60264,61.10174,1.8292.03455-.00339-.08485-3.00781-61.4445C571.12883,299.85439,570.32365,299.98376,569.52825,300.12331Z",
    transform: "translate(-43 -153.22928)",
    fill: "#65617d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M563.37184,301.63747l3.745,60.69058.00781.11482,3.16133-.27435-.02425-.29963-4.58332-60.92079C564.86177,301.157,564.08461,301.38666,563.37184,301.63747Z",
    transform: "translate(-43 -153.22928)",
    fill: "#65617d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M630.06181,349.83527s6.70108-31.40992-7.22416-33.29337-59.84367.61486-58.71776,13.59973,2.24935,32.70082,2.24935,32.70082l9.51-1.93944s-6.54242-29.79029,4.56867-30.7023,38.334-3.5141,38.334-3.5141,7.37527-1.10721,2.64682,24.85536Z",
    transform: "translate(-43 -153.22928)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M630.00533,352.82581s6.73873-33.40362-7.18651-35.28707-59.84367.61486-58.71776,13.59974,2.24935,32.70081,2.24935,32.70081l9.51-1.93944s-6.54242-29.79029,4.56866-30.70229,38.334-3.51411,38.334-3.51411,7.33761.88649,2.60917,26.84906Z",
    transform: "translate(-43 -153.22928)",
    fill: "#dce0ed"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M382.957,389.8778l12.29432.06266c9.71838-39.3704,24.97094-63.67831,24.97094-63.67831,5.0345-2.56745,59.52075-1.20431,59.52075-1.20431,5.63327,1.10359,6.78965,19.075,6.78965,19.075s-4.89815,4.06081-.29813,6.81023c2.056,1.2255,8.89012,1.57895,16.77784,1.32406,9.79361-.32361,21.21563-1.59371,27.13673-3.32172,10.69912-3.12362,2.342-9.42918,2.342-9.42918s-1.45762-2.02193-2.24736-13.00605a44.33217,44.33217,0,0,0-5.724-18.21229c-.44413-.77126-.72541-1.19042-.72541-1.19042a5.74958,5.74958,0,0,0-1.9209-1.25284c-13.97432-6.14744-83.11666-1.849-83.11666-1.849l-25.73786,7.661c-.71312.27074-1.83874,2.05441-3.2389,4.90989C401.3681,333.764,382.957,389.8778,382.957,389.8778Z",
    transform: "translate(-43 -153.22928)",
    fill: "#65617d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M382.957,389.8778l12.29432.06266c9.71838-39.3704,24.97094-63.67831,24.97094-63.67831,5.0345-2.56745,59.52075-1.20431,59.52075-1.20431,5.63327,1.10359,6.78965,19.075,6.78965,19.075s-4.89815,4.06081-.29813,6.81023c2.056,1.2255,8.89012,1.57895,16.77784,1.32406,9.79361-.32361,21.21563-1.59371,27.13673-3.32172,10.69912-3.12362,2.342-9.42918,2.342-9.42918s-1.45762-2.02193-2.24736-13.00605a44.33217,44.33217,0,0,0-5.724-18.21229c-.44413-.77126-.72541-1.19042-.72541-1.19042a5.74958,5.74958,0,0,0-1.9209-1.25284c-13.97432-6.14744-83.11666-1.849-83.11666-1.849l-25.73786,7.661c-.71312.27074-1.83874,2.05441-3.2389,4.90989C401.3681,333.764,382.957,389.8778,382.957,389.8778Z",
    transform: "translate(-43 -153.22928)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M409.78,316.57658c23.79356-8.72987,88.7906-2.631,88.7906-2.631,7.02476-5.78072,20.036-5.92391,25.94913-5.64768-.44413-.77126-.72541-1.19042-.72541-1.19042a5.74958,5.74958,0,0,0-1.9209-1.25284c-13.97432-6.14744-83.11666-1.849-83.11666-1.849l-25.73786,7.661C412.3058,311.93743,411.18018,313.7211,409.78,316.57658Z",
    transform: "translate(-43 -153.22928)",
    fill: "#65617d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M494.70066,316.36553c1.398,5.17693,7.15443,25.8978,7.15443,25.8978a87.51618,87.51618,0,0,1,1.15729,10.00385c9.79361-.32361,21.21563-1.59371,27.13673-3.32172,10.69912-3.12362,2.342-9.42918,2.342-9.42918s-1.45762-2.02193-2.24736-13.00605a44.14756,44.14756,0,0,0-6.44941-19.40271,5.74958,5.74958,0,0,0-1.9209-1.25284C512.59655,307.85835,493.64284,312.44649,494.70066,316.36553Z",
    transform: "translate(-43 -153.22928)",
    fill: "#65617d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M494.70066,316.36553c1.398,5.17693,7.15443,25.8978,7.15443,25.8978a87.51618,87.51618,0,0,1,1.15729,10.00385c9.79361-.32361,21.21563-1.59371,27.13673-3.32172,10.69912-3.12362,2.342-9.42918,2.342-9.42918s-1.45762-2.02193-2.24736-13.00605a44.14756,44.14756,0,0,0-6.44941-19.40271,5.74958,5.74958,0,0,0-1.9209-1.25284C512.59655,307.85835,493.64284,312.44649,494.70066,316.36553Z",
    transform: "translate(-43 -153.22928)",
    fill: "#fff",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M350.217,178.516l30.51477,100.29641L507.97338,260.399l-16.81124-60.27421s-2.60706-13.76075-9.19233-14.88233C481.96981,185.24246,380.25194,165.621,350.217,178.516Zm14.16244,15.72409c-4.107-13.53978,56.34542-6.78878,56.34542-6.78878,8.13906-.62909,17.94858.05478,27.06708,1.15938,3.3379.40707,6.58.87217,9.61745,1.34838,6.7758,1.06531,12.52815,2.20107,15.96989,2.91926,2.19022.45519,3.44625.74318,3.44625.74318,12.01615,3.96645,17.92811,53.93815,17.92811,53.93815.898,5.25227-5.3111,4.01315-5.3111,4.01315l-.404.00731-5.66123.11247-16.87916.34435-82.30046,1.66161c-4.85021-.5902-5.48958-6.33619-5.48958-6.33619C376.16907,243.201,364.37946,194.24009,364.37946,194.24009Z",
    transform: "translate(-43 -153.22928)",
    fill: "#65617d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M489.03856,251.58012l.404-.00731s6.20911,1.23912,5.3111-4.01315c0,0-5.912-49.9717-17.92811-53.93815,0,0-1.256-.288-3.44625-.74318C477.60868,201.52417,491.13532,231.11228,489.03856,251.58012Z",
    transform: "translate(-43 -153.22928)",
    fill: "#65617d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M489.03856,251.58012l.404-.00731s6.20911,1.23912,5.3111-4.01315c0,0-5.912-49.9717-17.92811-53.93815,0,0-1.256-.288-3.44625-.74318C477.60868,201.52417,491.13532,231.11228,489.03856,251.58012Z",
    transform: "translate(-43 -153.22928)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M475.55213,374.30024a8.02234,8.02234,0,0,0,7.43169,4.35354l2.53906-.06175,23.97368-.57933,8.63974-.21078,7.98729-.51226L631.753,362.1926l-.60646-10.39232-12.14443,1.50578-5.02269.62313-74.55062,9.23211-9.8105,1.21578-4.75776.58823-20.10366-.52427-21.76309-.57059a8.22136,8.22136,0,0,0-3.22152.55742,7.82152,7.82152,0,0,0-4.29235,3.9277A6.56646,6.56646,0,0,0,475.55213,374.30024Z",
    transform: "translate(-43 -153.22928)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M475.53331,375.29709a8.02232,8.02232,0,0,0,7.43169,4.35354l35.15248-.85186,7.98728-.51226,112.64377-16.10138,8.85407-1.26376,4.82457-.69169c9.50768-1.81483,6.86049-11.33824,6.86049-11.33824-.5813-4.33386-16.78945-8.62878-22.10585-8.55965-3.57576.04217-4.1782,5.54032-4.18645,9.145-.00342,1.765.13142,3.07384.13142,3.07384l-5.26758.65341L524.84172,365.96216,482.975,364.8673a8.04529,8.04529,0,0,0-7.51387,4.48511A6.56648,6.56648,0,0,0,475.53331,375.29709Z",
    transform: "translate(-43 -153.22928)",
    fill: "#dce0ed"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M644.70971,346.45551s-4.58936,5.39793-11.583,6.09685C633.12675,352.55236,636.06724,346.45849,644.70971,346.45551Z",
    transform: "translate(-43 -153.22928)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M645.58087,361.92858s14.79282-.053,14.6422,7.92175-9.47961,9.12817-9.47961,9.12817l-132.5621,22.925L480.621,401.8589s-12.92745-10.71477.784-15.10941l37.8613,1.71227,126.371-20.71511S642.39909,363.19809,645.58087,361.92858Z",
    transform: "translate(-43 -153.22928)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M480.60214,402.85574l37.55871.04621L636.03109,382.5166l8.62406-1.49248,6.0678-1.04715s9.33068-1.155,9.4813-9.12979c.10806-5.72192-7.48551-7.31126-11.78012-7.75138-1.687-.17145-2.86377-.16875-2.86377-.16875-3.18006,1.2662.05969,5.81479.05969,5.81479l-4.60141.75574L519.24737,389.46026l-37.8613-1.71227C467.67635,392.141,480.60214,402.85574,480.60214,402.85574Z",
    transform: "translate(-43 -153.22928)",
    fill: "#dce0ed"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M634.57181,355.23885l-7.74273-3.63643-3.98424-.24145-.30156,33.56673,12.34149-2.25991,5.21312-3.22555,2.7557-13.90876s-.887-5.83376-1.376-6.3416S634.57181,355.23885,634.57181,355.23885Z",
    transform: "translate(-43 -153.22928)",
    fill: "#dce0ed"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M634.57181,355.23885l-7.74273-3.63643-3.98424-.24145-.30156,33.56673,12.34149-2.25991,5.21312-3.22555,2.7557-13.90876s-.887-5.83376-1.376-6.3416S634.57181,355.23885,634.57181,355.23885Z",
    transform: "translate(-43 -153.22928)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M636.03109,382.5166c-.09686.11283-.14785.1717-.14785.1717l8.66911-1.50161c.03593-.05416.07186-.10832.1028-.16257,4.69425-7.25575,5.19559-13.20952,3.769-17.92832-1.687-.17145-2.86377-.16875-2.86377-.16875-3.18006,1.2662.05969,5.81479.05969,5.81479l-4.60141.75574C641.20362,376.07265,636.893,381.49578,636.03109,382.5166Z",
    transform: "translate(-43 -153.22928)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M623.84006,351.37808q2.17461.8862,4.01914,1.826c5.53646,2.797,8.93348,5.88269,10.88933,8.98105l8.85407-1.26376c-3.67765-8.02713-12.75017-11.82831-12.75017-11.82831l-1.85707.38377Z",
    transform: "translate(-43 -153.22928)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M633.8572,349.076s24.07458,10.0943,9.69828,32.0936l-8.67071,1.49824s17.48278-19.28143-12.03993-31.30682Z",
    transform: "translate(-43 -153.22928)",
    fill: "#dce0ed"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "532.836 205.554 523.871 205.052 524.685 241.133 539.19 238.748 545.393 235.873 548.353 228.783 550.481 221.676 545.786 215.106 540.372 211.347 532.836 205.554",
    fill: "#dce0ed"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "532.836 205.554 523.871 205.052 524.685 241.133 539.19 238.748 545.393 235.873 548.353 228.783 550.481 221.676 545.786 215.106 540.372 211.347 532.836 205.554",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 576.48162,
    cy: 377.40975,
    rx: 7.3115,
    ry: 4.32043,
    transform: "translate(145.25334 793.4326) rotate(-88.91801)",
    fill: "#dce0ed"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M617.49235,388.11168a2.34444,2.34444,0,0,1,1.11382,3.29714c-1.01331,1.81335-2.233,4.1605-2.1343,4.78893.1669,1.06267-2.18413.14572-2.49094-.10937s-4.61041-.08708-4.80432-3.02a5.06964,5.06964,0,0,1,2.38993-4.44227l-.87565-6.436,5.92819-.38664-.17291,5.85529Z",
    transform: "translate(-43 -153.22928)",
    fill: "#636780"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M617.49235,388.11168a2.34444,2.34444,0,0,1,1.11382,3.29714c-1.01331,1.81335-2.233,4.1605-2.1343,4.78893.1669,1.06267-2.18413.14572-2.49094-.10937s-4.61041-.08708-4.80432-3.02a5.06964,5.06964,0,0,1,2.38993-4.44227l-.87565-6.436,5.92819-.38664-.17291,5.85529Z",
    transform: "translate(-43 -153.22928)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M615.87956,387.95965s-2.12313,6.81566-1.2556,7.08134S615.87956,387.95965,615.87956,387.95965Z",
    transform: "translate(-43 -153.22928)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M613.66725,386.29742s-2.12313,6.81566-1.25559,7.08134S613.66725,386.29742,613.66725,386.29742Z",
    transform: "translate(-43 -153.22928)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M590.17275,365.20163l2.93532,20.6676s4.12262-.48556,6.39966-.93117a4.5624,4.5624,0,0,0,1.43885-.41659c.11682-.11246.36086-.0979.68359-.027l.005.0001c1.10228.24519,3.05869,1.19958,3.45708.43425a.67638.67638,0,0,1,.11274-.16239l.00509-.00489c.39678-.41631,1.14856-.093,1.87915.0305a1.59156,1.59156,0,0,0,1.16426-.13258c.62076-.39713,1.84941.28423,2.86207.52274.64031.15172,1.19412.13223,1.45924-.44112a1.34887,1.34887,0,0,1,1.00522-.689l.005.00009c.96149-.22119,2.29914-.03138,3.07479-.18127.30519-.05407.51669-.16474.59043-.37276.158-.44576,1.01931-.64389,1.93972-.801,1.11552-.19332,2.31466-.32527,2.41294-.77713.02774-.149.13863-.21177.30318-.21366a10.02985,10.02985,0,0,1,1.81079.483l.005.00009c.49607.134.90967.14682,1.03607-.2098.137-.39129.70935-.33563,1.35927-.1638.52588.13958,1.10519.35493,1.55178.46808.402.09734.69084.11777.74424-.0707.177-.6598,2.307.87623,2.83051-.44514s7.50323-9.99484-1.08738-21.6249c0,0-2.38559.11949-4.211.41408a6.57053,6.57053,0,0,0-1.76378.46029c-.01-.00019-.01506.00471-.0251.00951a10.22676,10.22676,0,0,1-3.20686.30839,4.18323,4.18323,0,0,0-1.79234.39,1.17157,1.17157,0,0,0-.50849.52387c-.29107.62774-.93152.74528-1.62854.69222-.941-.07261-1.98092-.45123-2.36826-.2691a.24448.24448,0,0,1-.03517.01431c-.70346.28586-3.30474-.05244-3.75653.37281a.25057.25057,0,0,0-.03565.03919c-.19467.27557-1.21088-.03781-2.24993-.19706l-.005-.00009a2.53791,2.53791,0,0,0-2.06959.285,2.25928,2.25928,0,0,1-1.62891.4479,9.34486,9.34486,0,0,0-2.11491.04481.84333.84333,0,0,0-.42368.25624c-.43353.51537-1.444.42647-2.347.45427a2.38594,2.38594,0,0,0-1.32711.309,1.18385,1.18385,0,0,1-.48226.19032,14.27034,14.27034,0,0,1-4.00354-.275Z",
    transform: "translate(-43 -153.22928)",
    fill: "#636780"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M626.11718,381.81578c.52588.13958,1.10519.35493,1.55178.46808,6.94631-10.33942,1.41446-18.39658-1.72365-21.72666a6.57053,6.57053,0,0,0-1.76378.46029C630.80738,368.96568,627.47783,378.67538,626.11718,381.81578Z",
    transform: "translate(-43 -153.22928)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M621.90606,381.70633a10.02985,10.02985,0,0,1,1.81079.483l.005.00009c5.96958-10.10357.17261-17.85162-2.77227-20.854a4.18323,4.18323,0,0,0-1.79234.39C625.48828,368.91509,623.40331,377.671,621.90606,381.70633Z",
    transform: "translate(-43 -153.22928)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M616.65979,383.87089c.30519-.05407.51669-.16474.59043-.37276.158-.44576,1.01931-.64389,1.93972-.801,5.23867-9.15508.84217-16.34317-2.16974-19.75566-.941-.07261-1.98092-.45123-2.36826-.2691a.24448.24448,0,0,1-.03517.01431C621.61276,370.8363,617.97212,380.914,616.65979,383.87089Z",
    transform: "translate(-43 -153.22928)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M611.11555,385.18221c.64031.15172,1.19412.13223,1.45924-.44112a1.34887,1.34887,0,0,1,1.00522-.689l.005.00009c6.10587-10.19077.22539-18.00519-2.72476-20.99268a.25057.25057,0,0,0-.03565.03919c-.19467.27557-1.21088-.03781-2.24993-.19706C616.80805,371.53332,612.27917,382.7062,611.11555,385.18221Z",
    transform: "translate(-43 -153.22928)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M605.21007,384.76155c.39678-.41631,1.14856-.093,1.87915.0305,6.34868-10.11139.8375-17.94378-2.218-21.15761a9.34486,9.34486,0,0,0-2.11491.04481C609.79741,371.55052,606.64568,381.34831,605.21007,384.76155Z",
    transform: "translate(-43 -153.22928)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M599.50773,384.93806a4.5624,4.5624,0,0,0,1.43885-.41659c.11682-.11246.36086-.0979.68359-.027l.005.0001c5.63414-9.23736,1.41424-16.53679-1.6496-20.10482a2.38594,2.38594,0,0,0-1.32711.309,1.18385,1.18385,0,0,1-.48226.19032C603.99689,372.70241,600.82128,381.91642,599.50773,384.93806Z",
    transform: "translate(-43 -153.22928)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 438.1642,
    cy: 397.06823,
    rx: 39.88093,
    ry: 27.0858,
    transform: "translate(-10.10717 674.42711) rotate(-88.91801)",
    fill: "#636780"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 439.067,
    cy: 397.66698,
    rx: 32.32017,
    ry: 19.69121,
    transform: "translate(-9.82007 675.91719) rotate(-88.91801)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 439.08582,
    cy: 396.67014,
    rx: 32.32017,
    ry: 19.69121,
    transform: "translate(-8.80493 674.95799) rotate(-88.91801)",
    fill: "#f0f0f4"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 435.92328,
    cy: 374.92129,
    rx: 3.98809,
    ry: 2.32639,
    transform: "translate(9.83722 650.45785) rotate(-88.91801)",
    fill: "#636780"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 425.96045,
    cy: 409.63516,
    rx: 3.98809,
    ry: 2.32639,
    transform: "translate(-34.64517 674.55515) rotate(-88.91801)",
    fill: "#636780"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 451.36151,
    cy: 393.49488,
    rx: 3.98809,
    ry: 2.32639,
    transform: "translate(6.41364 684.11618) rotate(-88.91801)",
    fill: "#636780"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 444.11043,
    cy: 416.62595,
    rx: 3.98809,
    ry: 2.32639,
    transform: "translate(-23.82746 699.56069) rotate(-88.91801)",
    fill: "#636780"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.35131,319.55824s-20.41749,51.46883-19.48183,54.72741c0,0-8.31811,4.8289-10.28827,3.54519s.20735-24.17821.20735-24.17821l4.11941-20.11552,4.46252-11.88213Z",
    transform: "translate(-43 -153.22928)",
    fill: "#65617d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.35131,319.55824s-20.41749,51.46883-19.48183,54.72741c0,0-8.31811,4.8289-10.28827,3.54519s.20735-24.17821.20735-24.17821l4.11941-20.11552,4.46252-11.88213Z",
    transform: "translate(-43 -153.22928)",
    opacity: 0.15
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 423.04555,
    cy: 387.97408,
    rx: 3.98809,
    ry: 2.32639,
    transform: "translate(-15.84781 650.38873) rotate(-88.91801)",
    fill: "#636780"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 435.49026,
    cy: 397.84873,
    rx: 9.47172,
    ry: 6.81299,
    transform: "translate(-13.51098 672.5194) rotate(-88.91801)",
    fill: "#636780"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.36145,388.4295c-.56669,30.00457,8.8859,57.50688,36.60484,55.0388,34.90371-.08869,38.0903-23.61279,38.657-53.61736s-15.85951-52.65258-36.64249-53.0451S218.92813,358.42494,218.36145,388.4295Z",
    transform: "translate(-43 -153.22928)",
    fill: "#636780"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.14279,388.47635c.43873-23.22992,10.89051-41.66538,25.23208-48.6255,18.17583,3.81334,31.80413,25.06076,31.28712,52.43526-.4644,24.589-2.69316,44.822-22.69094,51.37492C226.39627,444.097,217.59548,417.45535,218.14279,388.47635Z",
    transform: "translate(-43 -153.22928)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.898,375.442s4.90421,4.33073,7.702,1.392c0,0,7.74536-53.70257,16.22326-53.79175l29.16243.30148s3.46072,1.56116,4.83361,8.0689l17.84179,54.02128,103.3147,3.44706,8.20229-16.38366-85.4842-1.3652-.00922-.04007c-.43228-1.66352-13.74888-52.93184-23.22868-59.45805-.00489-.00508-.00988-.00518-.01478-.01026a4.16644,4.16644,0,0,0-1.042-.53322s-35.5478-5.40808-47.32192-2.38955c0,0-12.26313,2.51069-15.32427,6.19238a.3012.3012,0,0,0-.02548.02943c-.40664.41113-5.13038,5.5323-6.84467,20.53274Z",
    transform: "translate(-43 -153.22928)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.87919,376.43887s4.90422,4.33073,7.702,1.392c0,0,7.74537-53.70257,16.22326-53.79175l29.16243.30148s3.46072,1.56116,4.83362,8.06889l17.84178,54.02128L382.957,389.8778l8.20228-16.38365-85.4842-1.36521-.00922-.04007c-.43228-1.66352-13.74888-52.93183-23.22867-59.458-.0049-.00509-.00989-.00518-.01478-.01027a4.16683,4.16683,0,0,0-1.042-.53322s-35.5478-5.40808-47.32192-2.38955c0,0-12.26313,2.5107-15.32426,6.19239a.298.298,0,0,0-.02548.02943c-.40664.41113-5.13039,5.53229-6.84468,20.53273Z",
    transform: "translate(-43 -153.22928)",
    fill: "#65617d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.87919,376.43887s4.90422,4.33073,7.702,1.392c0,0,7.74537-53.70257,16.22326-53.79175l29.16243.30148s3.46072,1.56116,4.83362,8.06889l17.84178,54.02128L382.957,389.8778l8.20228-16.38365-85.4842-1.36521-.00922-.04007c-.43228-1.66352-13.74888-52.93183-23.22867-59.458-.0049-.00509-.00989-.00518-.01478-.01027a4.16683,4.16683,0,0,0-1.042-.53322s-35.5478-5.40808-47.32192-2.38955c0,0-12.26313,2.5107-15.32426,6.19239a.298.298,0,0,0-.02548.02943c-.40664.41113-5.13039,5.53229-6.84468,20.53273Z",
    transform: "translate(-43 -153.22928)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.28967,318.82051c2.40269,4.78208,22.73348,63.50232,22.73348,63.50232l14.65194-10.19389-.00922-.04007c-.43228-1.66352-13.76281-52.98693-23.24345-59.46831C276.162,313.56934,266.65574,315.57367,268.28967,318.82051Z",
    transform: "translate(-43 -153.22928)",
    fill: "#65617d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M296.705,292.68205l10.9881,38.59977,61.08972-.59133-.60667,5.72245s-47.98037,6.07422-68.23685-3.78177l-10.30321-35.26282-96.37114-1.32152,18.44016-3.97294Z",
    transform: "translate(-43 -153.22928)",
    fill: "#65617d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M296.705,292.68205l10.9881,38.59977,61.08972-.59133-.60667,5.72245s-47.98037,6.07422-68.23685-3.78177l-10.30321-35.26282-96.37114-1.32152,18.44016-3.97294Z",
    transform: "translate(-43 -153.22928)",
    fill: "#fff",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M581.82356,358.56382s32.41911,17.0661,7.87072,32.05908l-6.50773,1.3729s24.08134-16.6638-15.31883-33.69555Z",
    transform: "translate(-43 -153.22928)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M580.82671,358.545s32.41912,17.0661,7.87073,32.05908L582.1897,391.977s24.08135-16.6638-15.31882-33.69555Z",
    transform: "translate(-43 -153.22928)",
    fill: "#dce0ed"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 241.45809,
    cy: 393.10383,
    rx: 31.15697,
    ry: 18.19567,
    transform: "translate(-199.13515 473.86652) rotate(-88.91801)",
    fill: "#636780"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 242.05924,
    cy: 393.78777,
    rx: 25.25013,
    ry: 13.22814,
    transform: "translate(-199.22917 475.1386) rotate(-88.91801)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 242.07807,
    cy: 392.79092,
    rx: 25.25013,
    ry: 13.22814,
    transform: "translate(-198.21403 474.1794) rotate(-88.91801)",
    fill: "#f0f0f4"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 239.99837,
    cy: 375.80702,
    rx: 3.1157,
    ry: 1.56282,
    transform: "translate(-183.27358 455.43688) rotate(-88.91801)",
    fill: "#636780"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 233.23341,
    cy: 402.94647,
    rx: 3.1157,
    ry: 1.56282,
    transform: "translate(-217.04541 475.30009) rotate(-88.91801)",
    fill: "#636780"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 250.33166,
    cy: 390.28501,
    rx: 3.1157,
    ry: 1.56282,
    transform: "translate(-187.61082 479.97292) rotate(-88.91801)",
    fill: "#636780"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 245.41245,
    cy: 408.37024,
    rx: 3.1157,
    ry: 1.56282,
    transform: "translate(-210.51915 492.79832) rotate(-88.91801)",
    fill: "#636780"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 231.31989,
    cy: 386.03062,
    rx: 3.1157,
    ry: 1.56282,
    transform: "translate(-202.00996 456.7905) rotate(-88.91801)",
    fill: "#636780"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 239.66007,
    cy: 393.71909,
    rx: 7.39978,
    ry: 4.57683,
    transform: "translate(-201.51436 472.67247) rotate(-88.91801)",
    fill: "#636780"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M508.23907,259.53147s-55.36257.94879-127.50728,19.28094Z",
    transform: "translate(-43 -153.22928)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246.10181,157.69294s2.99512.53741,1.358,4.47344a27.4,27.4,0,0,0-1.916,5.97434s-3.0337,1.50544-2.81594-3.6595S246.10181,157.69294,246.10181,157.69294Z",
    transform: "translate(-43 -153.22928)",
    fill: "#dce0ed"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "319.533 99.18 323.943 116.733 339.136 103.42",
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("rect", {
    x: 339.74533,
    y: 268.91027,
    width: 45.57472,
    height: 44.78894,
    transform: "translate(11.50209 -210.35753) rotate(9.73905)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M356.88561,310.93213l.84487-4.92249a14.40243,14.40243,0,0,1-7.089-3.4244l1.73023-3.06487a15.26935,15.26935,0,0,0,7.21488,3.396c3.46033.59391,6.14279-1.003,6.61964-3.78124.46006-2.6805-1.1562-4.66384-4.51219-6.74509-4.63662-2.80279-6.76628-5.47634-6.03847-9.71676.69429-4.04519,3.81883-6.66977,8.42844-6.63136l.84487-4.92249,2.46546.42315-.81141,4.72754a13.1921,13.1921,0,0,1,6.04352,2.79353l-1.77067,3.00733a10.74276,10.74276,0,0,0-5.57869-2.66315c-3.75289-.64412-4.995,1.45044-5.3296,3.4-.435,2.53442.59472,4.016,4.53385,6.49835,4.66867,2.90836,7.32418,5.97322,6.57965,10.31112-.66083,3.85023-3.96041,6.99711-9.12257,6.96394l-.87,5.06884Z",
    transform: "translate(-43 -153.22928)",
    fill: "#636780"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M356.12166,470.89619a1.5009,1.5009,0,0,0,0-3,1.5009,1.5009,0,0,0,0,3Z",
    transform: "translate(-43 -153.22928)",
    fill: "#65617d"
  }))), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 663.90742,
    cy: 451.63248,
    rx: 18.67648,
    ry: 3.15725,
    fill: "#a0182f",
    opacity: 0.1
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M694.36474,590.19087s10.65346-.32812,13.86414-2.6144,16.3877-5.01624,17.18419-1.34953,16.01017,18.23649,3.98247,18.33351-27.947-1.8735-31.15153-3.82549S694.36474,590.19087,694.36474,590.19087Z",
    transform: "translate(-43 -153.22928)",
    fill: "#a8a8a8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M729.61019,603.28405c-12.0277.097-27.947-1.87348-31.15153-3.82548-2.4404-1.48654-3.41288-6.82063-3.73826-9.28157-.22534.00969-.35565.01386-.35565.01386s.67476,8.59209,3.87927,10.54409,19.12382,3.92252,31.15152,3.82548c3.47192-.028,4.67119-1.26326,4.60534-3.09278C733.51855,602.573,732.19438,603.26322,729.61019,603.28405Z",
    transform: "translate(-43 -153.22928)",
    opacity: 0.2
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 772.23501,
    cy: 414.84369,
    rx: 14.37168,
    ry: 2.42952,
    fill: "#a0182f",
    opacity: 0.1
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M805.58333,556.78361s8.19791-.25249,10.66856-2.0118,12.61045-3.86,13.22336-1.03848,12.31994,14.03312,3.06454,14.10777-21.50544-1.44167-23.97133-2.94374S805.58333,556.78361,805.58333,556.78361Z",
    transform: "translate(-43 -153.22928)",
    fill: "#a8a8a8"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M832.705,566.85891c-9.25541.07467-21.50543-1.44166-23.97133-2.94374-1.87791-1.14391-2.62623-5.24852-2.87662-7.14224-.1734.00746-.27367.01067-.27367.01067s.51923,6.61168,2.98512,8.11375,14.71593,3.01841,23.97133,2.94374c2.67167-.02155,3.59451-.97209,3.54384-2.37992C835.71247,566.31175,834.69352,566.84287,832.705,566.85891Z",
    transform: "translate(-43 -153.22928)",
    opacity: 0.2
  })), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 707.02732,
    cy: 568.43844,
    rx: 34.30916,
    ry: 5.79994,
    fill: "#a0182f",
    opacity: 0.1
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M726.98611,694.71692s19.57067-.60276,25.46877-4.80272,30.10463-9.215,31.5678-2.47913,29.41109,33.5009,7.3159,33.67913-51.3394-3.44167-57.22615-7.02752S726.98611,694.71692,726.98611,694.71692Z",
    transform: "translate(-43 -153.22928)",
    fill: "#a8a8a8"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M791.73289,718.76943c-22.09519.17827-51.33938-3.44164-57.22615-7.02751-4.48308-2.73082-6.26954-12.52967-6.86728-17.05048-.41395.0178-.65334.02546-.65334.02546s1.23956,15.78389,7.12632,19.36976,35.13095,7.20578,57.22615,7.02751c6.378-.05144,8.58108-2.32064,8.46011-5.68152C798.91265,717.4632,796.48013,718.73116,791.73289,718.76943Z",
    transform: "translate(-43 -153.22928)",
    opacity: 0.2
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M1112.28952,517.50307a89.33035,89.33035,0,0,1-178.33139,7.66639c-.12993-1.45095-.22735-2.902-.27071-4.37461v-.0758q-.06493-1.608-.065-3.216a89.33354,89.33354,0,0,1,178.66707,0Z",
    transform: "translate(-43 -153.22928)",
    fill: "#65617d"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M1112.28952,517.50307a89.33035,89.33035,0,0,1-178.33139,7.66639c-.12993-1.45095-.22735-2.902-.27071-4.37461v-.0758q-.06493-1.608-.065-3.216a89.33354,89.33354,0,0,1,178.66707,0Z",
    transform: "translate(-43 -153.22928)",
    opacity: 0.2
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 979.95349,
    cy: 364.27379,
    r: 48.72738,
    fill: "#dce0ed"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 979.95349,
    cy: 364.27379,
    r: 29.23643,
    fill: "#65617d"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M635.37776,517.50307a89.33035,89.33035,0,0,1-178.3314,7.66639c-.12993-1.45095-.22735-2.902-.2707-4.37461v-.0758q-.06493-1.608-.065-3.216a89.33354,89.33354,0,0,1,178.66707,0Z",
    transform: "translate(-43 -153.22928)",
    fill: "#65617d"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M635.37776,517.50307a89.33035,89.33035,0,0,1-178.3314,7.66639c-.12993-1.45095-.22735-2.902-.2707-4.37461v-.0758q-.06493-1.608-.065-3.216a89.33354,89.33354,0,0,1,178.66707,0Z",
    transform: "translate(-43 -153.22928)",
    opacity: 0.2
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 503.04172,
    cy: 364.27379,
    r: 48.72738,
    fill: "#dce0ed"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 503.04172,
    cy: 364.27379,
    r: 29.23643,
    fill: "#65617d"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M1140.15257,500.76362l-29.807-1.296-27.21508-50.54228-95.90073-7.77574-46.65441,60.90993,2.59191,16.84742-6.4798,15.55148-304.54961,2.59191v-7.77574H629.546l-2.59192-11.6636h23.32721l-16.84743-18.14338-59.614-50.54228s-102.38051,2.59191-103.67647,0,5.8318-29.159,5.8318-29.159l44.0625-12.95956,150.33089-11.6636c33.04687-52.48622,62.85386-77.10938,62.85386-77.10938h386.19485l18.14338,93.30883v.22021Z",
    transform: "translate(-43 -153.22928)",
    fill: "#444053"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M925.0239,507.2434s38.87867-72.57353,68.68566-72.57353h72.57353s18.14338,0,25.91912,14.25552l29.807,58.318H1098.682s-19.43934-54.43015-41.47059-55.7261-59.614,0-59.614,0-12.95956,0-20.7353,15.55147-34.06581,49.427-34.06581,49.427S914.65625,525.38678,925.0239,507.2434Z",
    transform: "translate(-43 -153.22928)",
    fill: "#33323d"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "1114 342.351 1065.252 342.351 1064.754 381.229 1114 369.566 1114 342.351",
    fill: "#33323d"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M452,472.25259s2.59191-19.43934,20.73529-27.21507l119.228-6.47978s19.43933,1.296,29.807,25.91912l33.69485,50.54228v7.77573H617.88235s-18.14338-68.68566-69.98161-66.09375H485.69485s-14.25551,0-19.43934,23.32721Z",
    transform: "translate(-43 -153.22928)",
    fill: "#33323d"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M731.92647,325.80956v0h397.85846v0a14.25551,14.25551,0,0,0-14.2555-14.2555H746.182A14.25551,14.25551,0,0,0,731.92647,325.80956Z",
    transform: "translate(-43 -153.22928)",
    fill: "#33323d"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M817.18914,402.271H707.0934a7.44346,7.44346,0,0,1-6.80191-10.46653l17.42127-39.19784a34.21209,34.21209,0,0,1,31.26341-20.31725h66.89151a9.36761,9.36761,0,0,1,9.36761,9.36762v52.56784A8.04615,8.04615,0,0,1,817.18914,402.271Z",
    transform: "translate(-43 -153.22928)",
    fill: "#a0182f",
    opacity: 0.3
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 810.74632,
    y: 179.06008,
    width: 107.56434,
    height: 69.98162,
    rx: 5.53937,
    fill: "#a0182f",
    opacity: 0.3
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    points: "1094.561 258.113 1094.561 258.334 927.382 260.705 923.028 164.805 1076.417 164.805 1094.561 258.113",
    fill: "#33323d"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 941.63787,
    y: 179.06008,
    width: 123.11581,
    height: 69.98162,
    rx: 5.53937,
    fill: "#a0182f",
    opacity: 0.3
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 748.54044,
    y: 273.66486,
    width: 41.47059,
    height: 7.77574,
    rx: 1.75984,
    fill: "#33323d"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 867.76838,
    y: 273.66486,
    width: 41.47059,
    height: 7.77574,
    rx: 1.75984,
    fill: "#33323d"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 951.74716,
    y: 171.32088,
    width: 47.99028,
    height: 47.16286,
    fill: "#fff"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M1016.37779,369.50731v-5.25919a15.16587,15.16587,0,0,1-7.96711-2.29119l1.24974-3.489a16.0787,16.0787,0,0,0,8.09272,2.23927c3.697,0,6.19649-2.13513,6.19649-5.10341,0-2.86384-2.03068-4.63431-5.88434-6.19649-5.31126-2.0829-7.99772-4.47824-7.99772-9.0087,0-4.32188,2.77523-7.60231,7.566-8.38354v-5.25919h2.63409v5.0509a13.89138,13.89138,0,0,1,6.76973,1.82268l-1.302,3.4365a11.31211,11.31211,0,0,0-6.26409-1.77018c-4.00959,0-4.92557,2.39505-4.92557,4.478,0,2.70777,1.33256,4.06195,5.86288,5.93656,5.36333,2.18676,8.66522,4.89453,8.66522,9.52914,0,4.11359-2.86384,7.96725-8.22718,8.85234v5.41555Z",
    transform: "translate(-43 -153.22928)",
    fill: "#636780"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M413.615,571.34036c-6.19649,6.73726-10.75751,9.38918-10.54248,2.28051.65157-21.502-37.12675-118.717-37.12675-118.717l11.1745-.847C401.50221,496.10947,410.5656,539.32194,413.615,571.34036Z",
    transform: "translate(-43 -153.22928)",
    fill: "none"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M466.92034,618.25377a53.753,53.753,0,0,1-107.30793,4.61313c-.07818-.87309-.1368-1.74622-.16289-2.63235v-.04562q-.03908-.96758-.03909-1.93516a53.755,53.755,0,0,1,107.50991,0Z",
    transform: "translate(-43 -153.22928)",
    fill: "#65617d"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 370.16388,
    cy: 465.02449,
    r: 29.32088,
    fill: "#dce0ed"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 370.16388,
    cy: 465.02449,
    r: 17.59253,
    fill: "#65617d"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M271.99511,516.17145l-129.442,2.6063V499.66708c1.15982-15.35763,16.90838-20.74617,31.28213-22.43373a89.77451,89.77451,0,0,1,33.44537,2.50855c27.46387,7.27156,44.97821,8.679,53.579,8.81583a8.219,8.219,0,0,1,7.94923,6.68513c.4105,2.1828.81447,4.561,1.19239,6.90672.2867,1.83745.56035,3.64881.808,5.3364C271.51943,512.37932,271.99511,516.17145,271.99511,516.17145Z",
    transform: "translate(-43 -153.22928)",
    fill: "#65617d"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M375.26326,621.72664H106.36468a10.58547,10.58547,0,0,1-9.8062-6.33982c-2.02642-4.84119.80795-7.92965,3.83127-9.741a30.46331,30.46331,0,0,0,13.24-16.19815c2.86691-8.43791,5.66868-21.7235,6.76984-42.43058,1.13373-21.41727,8.88749-32.00537,17.26674-37.13326h.00652c10.82266-6.62,22.68786-4.13753,22.68786-4.13753l109.02809.87313a20.95669,20.95669,0,0,1,5.32336,3.47291c9.715,9.04386-4.45027,20.8504-4.45027,20.8504-30.409,32.14218-7.38884,64.72094-7.38884,64.72094h55.78787a51.33863,51.33863,0,0,0,29.22313-8.94612c7.53873-5.20607,10.45777-10.24926,11.585-13.29863.86009-2.33265,1.73318-4.65878,2.77572-6.91324,14.63436-31.7382-3.01679-83.369-10.63371-102.6752-1.88958-4.8021-3.16016-7.60391-3.16016-7.60391l17.49481-1.32267,11.06374-.84052.11076-.00652c24.382,42.05265,33.44536,85.26512,36.49473,117.28354.28669,3.01679.52125,5.94236.71023,8.75065A39.10084,39.10084,0,0,1,375.26326,621.72664Z",
    transform: "translate(-43 -153.22928)",
    fill: "#a0182f"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M270.80924,507.486H142.55316v-5.3364H270.00129C270.288,503.987,270.56164,505.79839,270.80924,507.486Z",
    transform: "translate(-43 -153.22928)",
    opacity: 0.1
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M274.71217,510.09229H138.70236a2.57218,2.57218,0,0,1-1.0295-.20851c10.82266-6.62,22.68786-4.13753,22.68786-4.13753l109.02809.87313A20.95669,20.95669,0,0,1,274.71217,510.09229Z",
    transform: "translate(-43 -153.22928)",
    opacity: 0.1
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 45.44843,
    y: 350.22611,
    width: 190.06459,
    height: 5.33374,
    rx: 2.66687,
    fill: "#dce0ed"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M413.615,571.34036c-6.19649,6.73726-10.75751,9.38918-10.54248,2.28051.65157-21.502-37.12675-118.717-37.12675-118.717l11.1745-.847C401.50221,496.10947,410.5656,539.32194,413.615,571.34036Z",
    transform: "translate(-43 -153.22928)",
    opacity: 0.1
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M466.59455,612.36351c-6.418,1.53774-14.35418,3.1015-24.14085,4.535q-5.45372.80145-11.70231,1.53771c-9.98862,1.18587-21.54108,2.2219-34.88532,3.0168q-5.66869.3421-11.774.619-11.43516.518-24.47969.79491l-.16289-2.63235v-.04562c12.15189-4.90634,31.26909-17.9965,34.35106-52.09345a53.783,53.783,0,0,1,72.794,44.268Z",
    transform: "translate(-43 -153.22928)",
    opacity: 0.1
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M349.31753,621.72664s61.70418-6.68387,40.46283-100.71164c0,0,30.49066,27.948,49.45455,43.48382S492,601.45,492,601.45,471.81367,620.31548,349.31753,621.72664Z",
    transform: "translate(-43 -153.22928)",
    fill: "#a0182f"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M349.31753,621.72664s61.70418-6.68387,40.46283-100.71164c0,0,30.49066,27.948,49.45455,43.48382S492,601.45,492,601.45,471.81367,620.31548,349.31753,621.72664Z",
    transform: "translate(-43 -153.22928)",
    fill: "#fff",
    opacity: 0.1
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 141.469,
    cy: 465.02449,
    r: 53.75496,
    fill: "#65617d"
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 141.469,
    cy: 465.02449,
    r: 29.32088,
    fill: "#dce0ed"
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: 141.469,
    cy: 465.02449,
    r: 17.59253,
    fill: "#65617d"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M244.73971,602.11058c0-34.7145-27.56754-62.85615-61.57386-62.85615S121.592,567.39608,121.592,602.11058c0,1.46475.0532,2.91664.14975,4.35636H244.59C244.68652,605.02722,244.73971,603.57533,244.73971,602.11058Z",
    transform: "translate(-43 -153.22928)",
    opacity: 0.1
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M242.4592,601.02725c0-33.42878-26.54652-60.52815-59.29335-60.52815s-59.29334,27.09937-59.29334,60.52815c0,1.41051.05122,2.80861.1442,4.195H242.315C242.408,603.83586,242.4592,602.43776,242.4592,601.02725Z",
    transform: "translate(-43 -153.22928)",
    fill: "#a0182f"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M242.4592,601.02612c0,.97084-.026,1.93516-.07167,2.893-.01956.43654-.04561.86656-.07166,1.30315h-118.3c-.026-.43659-.05209-.86661-.07166-1.30315-.04561-.95784-.07166-1.92216-.07166-2.893,0-33.4258,26.54516-60.52483,59.29334-60.52483S242.4592,567.60032,242.4592,601.02612Z",
    transform: "translate(-43 -153.22928)",
    fill: "#fff",
    opacity: 0.1
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M242.38753,603.91912c-.01956.43654-.04561.86656-.07166,1.30315h-118.3c-.026-.43659-.05209-.86661-.07166-1.30315Z",
    transform: "translate(-43 -153.22928)",
    opacity: 0.1
  })), _ellipse5 || (_ellipse5 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 394.91977,
    cy: 496.63947,
    rx: 7.80344,
    ry: 19.65277,
    transform: "translate(-212.55202 53.61029) rotate(-24.33287)",
    opacity: 0.1
  })), _ellipse6 || (_ellipse6 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 395.57134,
    cy: 495.9879,
    rx: 7.80344,
    ry: 19.65277,
    transform: "translate(-212.22567 53.82088) rotate(-24.33287)",
    fill: "#dce0ed"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M377.00948,454.06334v10.21017h-19.873a34.24153,34.24153,0,0,1-5.52534-.44307c-1.88958-4.8021-3.16016-7.60391-3.16016-7.60391l17.49481-1.32267Z",
    transform: "translate(-43 -153.22928)",
    opacity: 0.1
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M377.00948,462.96949h-19.873c-17.453,0-31.60139-13.05818-31.60139-29.16627v-2.70615c0-16.10809,14.14842-29.16627,31.60139-29.16627l19.873,1.8041Z",
    transform: "translate(-43 -153.22928)",
    fill: "#a0182f"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M344.26782,419.19754s11.89125,6.35286,5.04971,17.10385c0,0-8.389,13.76453-21.58343,12.46138l-4.80536-29.56523S338.72943,417.7315,344.26782,419.19754Z",
    transform: "translate(-43 -153.22928)",
    fill: "#a0182f"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M339.70327,418.62315a12.64112,12.64112,0,0,1,9.655,5.0947c2.11761,2.93208,3.38,7.20805-.04073,12.58354,0,0-8.389,13.76453-21.58343,12.46138l-4.80536-29.56523A147.02057,147.02057,0,0,1,339.70327,418.62315Z",
    transform: "translate(-43 -153.22928)",
    opacity: 0.1
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M333.3579,250.50562h0A15.96358,15.96358,0,0,1,349.3215,266.4692v27.30744a15.96358,15.96358,0,0,1-15.96358,15.96358h0a0,0,0,0,1,0,0V250.50562A0,0,0,0,1,333.3579,250.50562Z",
    opacity: 0.1
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M334.00948,250.50562h0a15.96358,15.96358,0,0,1,15.96358,15.96358v27.30744a15.96358,15.96358,0,0,1-15.96358,15.96358h0a0,0,0,0,1,0,0V250.50562A0,0,0,0,1,334.00948,250.50562Z",
    fill: "#dce0ed"
  })), _ellipse7 || (_ellipse7 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 278.55269,
    cy: 281.34462,
    rx: 13.20295,
    ry: 16.06215,
    fill: "#a0182f"
  })), _polyline || (_polyline = /*#__PURE__*/React.createElement("polyline", {
    points: "137.953 355.597 143.722 368.443 153.363 355.597",
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 119.70361,
    y: 368.9797,
    width: 47.04234,
    height: 46.23127,
    fill: "#fff"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M183.907,566.27811v-5.1553a14.86629,14.86629,0,0,1-7.80974-2.24594l1.22506-3.42009a15.76111,15.76111,0,0,0,7.93286,2.195c3.624,0,6.0741-2.09294,6.0741-5.00259,0-2.80728-1.99057-4.54278-5.76812-6.0741-5.20634-2.04176-7.83973-4.38979-7.83973-8.83076,0-4.23651,2.7204-7.45214,7.4166-8.21794v-5.1553h2.582v4.95112a13.61692,13.61692,0,0,1,6.636,1.78669l-1.27624,3.36862a11.08864,11.08864,0,0,0-6.14035-1.73522c-3.93039,0-4.82829,2.34774-4.82829,4.3895,0,2.65429,1.30625,3.98172,5.74708,5.81931,5.25739,2.14356,8.49406,4.79785,8.49406,9.34091,0,4.03233-2.80728,7.80988-8.06467,8.67748v5.30858Z",
    transform: "translate(-43 -153.22928)",
    fill: "#636780"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 51,
    y: 246.77072,
    width: 7,
    height: 108,
    fill: "#dce0ed"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M94,400s-26,1-31,3-20,1-20,1v28s17-4,26-1,28-4,28-4Z",
    transform: "translate(-43 -153.22928)",
    fill: "#dce0ed"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVehicleSale);
export default __webpack_public_path__ + "static/media/vehicle_sale.f8ea4bcab5089263038d842e36ba6cfd.svg";
export { ForwardRef as ReactComponent };